import {
  ActivityCode,
  UserActivityCode,
  DeviceActivityCode,
  NotificationActivityCode,
  PlatformActivityCode,
} from '@eppendorf/vnls-audit-event-client';
import { IconSizeClasses, type IconProps } from '@eppendorf/vnls-react-components';

const USER_ACTIVITY_CODES = new Set(Object.values(UserActivityCode));
const DEVICE_ACTIVITY_CODES = new Set(Object.values(DeviceActivityCode));
const NOTIFICATION_ACTIVITY_CODES = new Set(Object.values(NotificationActivityCode));
const PLATFORM_ACTIVITY_CODES = new Set(Object.values(PlatformActivityCode));

export const getIconNameForActivityCode = (
  code: ActivityCode,
): Pick<IconProps, 'name' | 'size'> => {
  if (code === ActivityCode.DEVICE_EVENT_ALERT) {
    return { name: 'event-alert', size: IconSizeClasses.XSmall }; // Device event icons appear a bit larger than other icons
  }
  if (code === ActivityCode.DEVICE_EVENT_ERROR) {
    return { name: 'event-error', size: IconSizeClasses.XSmall };
  }
  if (code === ActivityCode.DEVICE_EVENT_WARNING) {
    return { name: 'event-warning', size: IconSizeClasses.XSmall };
  }
  if (code === ActivityCode.DEVICE_EVENT_INFO) {
    return { name: 'event-notice', size: IconSizeClasses.XSmall };
  }
  if (USER_ACTIVITY_CODES.has(code as UserActivityCode)) {
    return { name: 'users_unmasked', size: IconSizeClasses.XSmall };
  }
  if (DEVICE_ACTIVITY_CODES.has(code as DeviceActivityCode)) {
    return { name: 'generic_unmasked', size: IconSizeClasses.Small };
  }
  if (NOTIFICATION_ACTIVITY_CODES.has(code as NotificationActivityCode)) {
    return { name: 'notifications_unmasked', size: IconSizeClasses.Small };
  }
  if (PLATFORM_ACTIVITY_CODES.has(code as PlatformActivityCode)) {
    return { name: 'maintenance_unmasked', size: IconSizeClasses.Small };
  }

  return { name: 'placeholder_unmasked', size: IconSizeClasses.Small };
};
